export const isStaging = () => window.location.href.indexOf('www-staging') >= 0;
export const isDevCluster = () => window.location.href.indexOf('labdevs.com') >= 0;
export const isProd = () => !(isProd() || isDevCluster());

// eslint-disable-next-line no-nested-ternary
export const environment = () => (isStaging() ? 'staging' : isDevCluster() ? 'dev' : 'prod');
